<template>
	<div class="NewOrderSendPopup">
		<div class="wrap-content mb-2">
			<div class="if-not">
				<p class="mr-4">
					Order To :
				</p>
				<div style="text-transform: capitalize; font-weight: 800;">
					{{ vendorSelectedForOrderName }}
				</div>
			</div>
			<!-- <div class="if-not">
				<p class="mr-4">
					Order Number
				</p>
				<div>
					<BaseInput placeholder="Order Number" type="number" />
				</div>
			</div> -->
		</div>
		<div class="" style="height: 260px; overflow: auto;">
			<table class="tableMain">
				<thead>
					<tr>
						<th colspan="1">
							Item
						</th>
						<th colspan="1">
							Order Quantity
						</th>
						<th colspan="1">
							Amount
						</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(actualItem, actualItemIndex) in actualItems"
						:key="actualItemIndex"
					>
						<td class="capitalize">
							{{ actualItem.item.article_info.name }}
						</td>
						<td>
							{{ actualItem.system_order_quantity }}
						</td>
						<td>
							<span>{{
								actualItemAmount(
									actualItem,
									actualItem.system_order_quantity,
									actualItem.item.article_info.default_cost
								)
							}}</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="m-3 pb-2 text-base summary-popup-section">
			<!-- <el-row class="mt-2" :gutter="20">
				<el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
					<p class="mt-2 text-xs">Order Amount</p>
				</el-col>
				<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6"
					><span class="text-xs">{{ actualItemsTotal }}</span>
				</el-col>
			</el-row>
			<el-row class="mt-2" :gutter="20">
				<el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
					<p class="mt-2 text-xs">Return:</p>
				</el-col>
				<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6"
					><span class="text-xs">{{ returnedItemsTotal }}</span>
				</el-col>
			</el-row>
			<el-row class="mt-2" :gutter="20">
				<el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
					<p class="mt-2 text-xs">Sub Total:</p>
				</el-col>
				<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6"
					><span class="text-xs">{{ totalOrderAmount }}</span>
				</el-col>
			</el-row> -->
			<el-row class="mt-4" :gutter="20">
				<el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
					<p class="mt-3 text-xs font-bold">GST :</p>
				</el-col>
				<el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
					<!-- <BaseInput
						v-model="tax"
						v-validate="'decimal:2'"
						placeholder="Tax"
						type="number"
						name="Tax"
					/> -->
					<el-select
						v-model="tax"
						style="width: 150px;"
						:name="`Tax`"
						size="small"
						placeholder="Tax"
					>
						<el-option label="0%" value="0" />
						<el-option label="5%" value="5" />
						<el-option label="12%" value="12" />
						<el-option label="18%" value="18" />
						<el-option label="28%" value="28" />
					</el-select>
					<span :v-show="errors.has('Tax')" class="text-red-dark text-xs">
						{{ errors.first("Tax") }}
					</span>
				</el-col>
			</el-row>
			<el-row class="mt-4" :gutter="20">
				<el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
					<p class="text-xs font-bold">Total (INR):</p>
				</el-col>
				<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6"
					><span class="text-xs">{{ totalOrderAmountWithTax }}</span>
				</el-col>
			</el-row>
		</div>
		<div class="bg-orange-100">
			<div class="buttons-parrent">
				<BaseButton
					type="submit"
					buttonclass="btn p-2 text-xs"
					style="width: 100px; display: inline-block; margin-right: 15px;"
					@click="$emit('closeDialog')"
				>
					Cancel
				</BaseButton>
				<BaseButton
					type="submit"
					buttonclass="btn p-2 text-xs"
					style="width: 100px; display: inline-block;"
					@click="$emit('sendOrder', { tax: tax })"
				>
					Place Order
				</BaseButton>
			</div>
		</div>
	</div>
</template>

<script>
import { NewOrderMixin } from "../../../../../mixins/newOrder.mixin";
export default {
	name: "NewOrderSendPopup",
	components: {},
	mixins: [NewOrderMixin],
	props: {
		order: {
			type: Object,
			default: () => {}
		},
		actualItems: {
			type: Array,
			default: () => []
		},
		returnedItems: {
			type: Array,
			default: () => []
		},
		vendorSelectedForOrderName: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			tax: null,
			setDelivery: "",
			orderTo: ""
		};
	},
	computed: {
		totalOrderAmountWithTax() {
			var totalOrderAmountWithTax =
				Number(this.totalOrderAmount) +
				(Number(this.totalOrderAmount) * Number(this.tax)) / 100;
			console.log("totalOrderAmountWithTax", totalOrderAmountWithTax);
			return totalOrderAmountWithTax % 1 != 0
				? Number(totalOrderAmountWithTax).toFixed(2)
				: totalOrderAmountWithTax;
		}
	}
};
</script>

<style lang="scss">
@import "./NewOrderSendPopup";
.NewOrder .Baseinput input {
	height: 30px !important;
	width: 100% !important;
}
</style>
